import*as React from"react";import styled from"@emotion/styled";import{Spinner}from"@wp/src/components/common";import{FlexFlipOnScreenSize,FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import Divider from"@wp/src/components/common/divider";import{Row}from"antd";import{AntdSelect}from"@wp/src/components/common";import EmptyState from"@wp/src/components/common/emptyState";import{OnboardingNavigationWrapper}from"@wp/src/components/screenComponents/onboarding/NavigationGuide/OnboardingNavigationWrapper";import{Body1W500Neutral800,Body2W400Neutral800}from"@wp/src/components/common/atoms";import{Icon as IconifyIcon}from"@wp/src/components/common";export const LinkAccountContainer=styled.div`
  background-color: ${props=>props.theme.colors.white};
`;export const FooterHead=styled.div`
  color: ${props=>props.theme.colors.neutral900};
  font-weight: 500;
  ${mediaQuery({fontSize:["8px","10px","12px","14px","16px","18px"]})}
`;export const FooterItemContainer=styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 8px;
  align-self: flex-end;
`;export const Icon=styled.div`
  &:before {
    background-image: ${props=>`url('${props.icon}')`};
    content: '';
    width: 20px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
  }
`;export const FooterDescription=styled.div`
  color: ${props=>props.theme.colors.neutral500};
  font-size: 12px;
  text-align: center;
`;export const InlineLink=styled.a`
  text-decoration: underline;
`;export const LinkAccountStyledDivider=styled(Divider)`
  margin: 8px 0;
`;export default LinkAccountStyledDivider;export const TopInstitutionsContainer=styled(FlexLayout)`
  ${mediaQuery({flexBasis:["100%","100%","80%"]})}
`;export const InstitutionsContainer=styled(Row)`
  ${props=>props.isMobilePortrait?"min-height: 160px; max-height: 196px; overflow-y:auto; scrollbar-color: black;":""}
`;export const SocialProofContainer=styled(FlexFlipOnScreenSize)`
  padding: 8px 16px;
  border-radius: var(--card-border-radius, 8px);
  background: ${props=>props.theme.colors.neutral50};
`;export const SocialProofQuoteContainer=styled.div`
  word-break: break-word;
  white-space: break-spaces;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  flex-grow: 1;
`;export const SocialProofQuoter=styled.div`
  font-weight: 600;
  color: ${props=>props.theme.colors.neutral400};
`;export const IconContainer=styled.div`
  background-color: ${props=>props.theme.colors.blue50};
  border-radius: 40px;

  ${mediaQuery({width:["32px","32px","40px","40px","48px"],height:["32px","32px","40px","40px","48px"]})}

  &:before {
    background-image: ${props=>`url('${props.icon}')`};
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    display: block;

    ${mediaQuery({width:["16px","16px","24px","24px","32px"],height:["16px","16px","24px","24px","32px"],margin:["8px","8px","8px","8px","8px"]})}
  }
`;export const InstitutionsLookupLoader=styled(Spinner)``;export const SearchLoaderContainer=styled.div`
  display: flex;
  align-items: flex-start;
`;export const PartnerContainer=styled.div`
  display: flex;
  column-gap: 24px;
`;export const PartnerImage=styled.img`
  height: 24px;
`;export const InstitutionSelect=styled(AntdSelect)`
  &.ant-select-single .ant-select-selector {
    border-radius: 8px;
    border: 1px solid ${props=>props.theme.colors.blue600};

    & > .ant-select-selection-placeholder {
      ${mediaQuery({fontSize:["12px","12px","14px"]})}
    }

    .ant-select-selection-search-input {
      font-size: 14px;
    }
  }

  .ant-select-item {
    border-radius: 0;
  }

  &.ant-select .ant-select-dropdown {
    .ant-select-item.ant-select-item-option {
      padding: 12px 8px 12px 8px;
      &:not(:last-child) {
        border-bottom: 1px solid ${props=>props.theme.colors.neutral300};
      }
      .ant-select-item-option-content .ant-divider {
        margin: 8px 0 0 0;
        height: 1px;
        background: ${props=>props.theme.colors.neutral200};
      }
    }
  }
`;export const OnboardingPersonalizationLoader=styled(EmptyState)`
  padding: 0 32px;
`;export const PersonalizationCompletedIndicator=()=>React.createElement(IconifyIcon,{icon:"lucide:check-circle",className:"pt-2 text-primary h-6 w-6 text-2xl"});export const QuestionLabel=styled(Body1W500Neutral800)`
  ${mediaQuery({fontSize:["18px"]})}
  text-align: center;
`;export const QuestionDescription=styled(Body2W400Neutral800)`
  text-align: center;
  color: ${props=>props.theme.colors.neutral500};
`;export const CenterAligner=styled(FlexLayout)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;export const StepValue=styled(Body2W400Neutral800)`
  color: ${props=>props.theme.colors.neutral500};
`;export const QuestionHeaderContainer=styled(CenterAligner)``;export const SpecialQuestionContainer=styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;export const InvestorPreferenceSelectContainer=styled.div`
  display: flex;
  align-items: center;
  background: ${props=>props.theme.colors.white};

  box-sizing: border-box;
  margin-top: 8px;
  border-radius: var(--card-border-radius, 8px);

  ${mediaQuery({width:["100%","560px"],padding:["16px","16px","32px 16px"]})};

  > div:first-of-type {
    margin-right: 12px;
  }

  label {
    display: block;
    padding-bottom: 4px;
  }
`;export const EstimatedIncomeContainer=styled(InvestorPreferenceSelectContainer)``;export const EstimatedNetWorthContainer=styled(InvestorPreferenceSelectContainer)``;export const IncomeInputContainer=styled.div`
  ${mediaQuery({display:["block","block","flex"]})};
  flex-basis: 90%;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > div {
    padding-bottom: 16px;

    > label {
      padding-bottom: 4px;
    }
  }

  & > div:first-of-type {
    flex-basis: 65%;

    & > * {
      display: block;
      width: 100%;
    }
  }

  & > div:nth-child(2) {
    flex-basis: 30%;

    .ant-select {
      width: 100%;
    }
  }
`;export const OnboardingSelectContainer=styled.div`
  width: inherit;
  max-width: 85%;

  .ant-select {
    width: 100% !important;
  }
`;export const OnboardingContainer=styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: inherit;
  margin: auto 0;
  padding-bottom: ${props=>props.contentOverflowSpacer}px;
`;export const OnboardingQuestionContainer=styled.div`
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  & > div {
    margin: auto;
  }
  min-height: 100%;
`;export const OnboardingPersonalizationPageContainer=styled(FlexLayout)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${mediaQuery({padding:["16px 0 0","16px 0 0","24px 0 0"]})}
`;export const OnboardingActionsContainer=styled(OnboardingNavigationWrapper)``;export const StepPageContainer=styled.div`
  box-sizing: border-box;

  ${mediaQuery({padding:["16px 8px 0","16px 8px 0","16px 16px 0","24px 16px 0"]})}
`;export const QuestionContainer=styled.div`
  ${mediaQuery({paddingBottom:["16px","16px","16px","16px","24px"]})}
`;export const QuestionOptionsContainer=styled(CenterAligner)`
  ${mediaQuery({paddingTop:["16px"]})}
`;export const OptionsContainer=styled.div`
  ${props=>mediaQuery({maxWidth:props.maxWidths})}
`;export const QuestionsContainer=styled.div`
  ${mediaQuery({padding:["8px 0","8px 0","16px 0"]})}

  ${props=>props.displayAtCenter&&`
  display: flex;
  align-items: center;
  flex-direction: column;
  `}
  ${props=>props.disableClickEvents&&"pointer-events: none"}
`;